import VueTypes from 'vue-types';

export const detailItemProps = {
  title: VueTypes.string.isRequired,
  path: VueTypes.string.isRequired,
  relations: VueTypes.arrayOf(VueTypes.string).def([]),
  hasAlert: VueTypes.bool.def(false),
  isTargetBlank: VueTypes.bool.def(false),
  isResrakuAvailable: VueTypes.bool.def(false),
};
export const VTDetailItem = VueTypes.shape(detailItemProps);

export const categoryItemProps = {
  title: VueTypes.string.isRequired,
  children: VueTypes.arrayOf(VTDetailItem).def([]),
  isForceCollapse: VueTypes.bool.def(false),
};
export const categoryLinkProps = {
  title: VueTypes.string.isRequired,
  path: VueTypes.string.def(''),
};
export const VTCategoryItem = VueTypes.shape(categoryItemProps);
export const VTCategoryLink = VueTypes.shape(categoryLinkProps);
export const VTCategory = VueTypes.oneOfType([VTCategoryItem, VTCategoryLink]);
export const VTCategories = VueTypes.arrayOf(VTCategory);
